
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.333 53.333H6.667V6.667h46.666m0-6.667H6.667A6.667 6.667 0 000 6.667v46.666A6.667 6.667 0 006.667 60h46.666A6.667 6.667 0 0060 53.333V6.667C60 2.967 57 0 53.333 0zM26.667 40h6.666v6.667h-6.666V40zm0-26.667h6.666v20h-6.666v-20z","fill":"#165A9F"}})])
          )
        }
      }
    